import type { FC } from 'react';
import { Table } from 'reactstrap';
import EmbedYoutube from '../../utils/EmbedYoutube/EmbedYoutube';
import { ProgrammmingLanguageWrapper } from './ProgrammmingLanguage.styled';

interface ProgrammmingLanguageProps {}

const ProgrammmingLanguage: FC<ProgrammmingLanguageProps> = () => (
 <ProgrammmingLanguageWrapper>	
   <header className="entry-header">
      <h1 className="entry-title" itemProp="headline">Programming language</h1>			
   </header>
   <div className="entry-content clear" itemProp="text"  style={{height: 'auto !important'}}>
      <p className="text-align-justify">A programming language mainly consists of a set of instructions to perform any specific task. It is basically the logic that one writes to provide detailed instructions, which then the compiler compiles into machine language that can be understood by the computer. The top 10 programming languages include Javascript, Java, Python, PHP, C++, C#, Typescript, Shell, C, Ruby.</p>
      <p className="text-align-justify">The two most commonly used programming languages are procedural programming and object-oriented programming :</p>

      <Table bordered striped className="text-align-justify">
         <thead>
            <tr>
               <th className="text-align-center" style={{width: '50%'}}><strong>Procedural Programming</strong></th>
               <th className="text-align-center"><strong>Object Oriented Programming</strong></th>
            </tr>
         </thead>
         <tbody>
            <tr>
               <td>A program is divided into small parts known as functions.</td>
               <td>A program is divided into small parts known as objects.</td>
            </tr>
            <tr>
               <td>It follows the top-down approach.</td>
               <td>It follows the bottom-up approach.</td>
            </tr>
            <tr>
               <td>Data hiding is not possible, so it is a less secure approach.</td>
               <td>Data hiding is possible, so it is a more secure approach.</td>
            </tr>
            <tr>
               <td>Adding new data and function is not as easy as the whole program needs to be revised.</td>
               <td>New data and functions can be created easily with existing objects.</td>
            </tr>
            <tr>
               <td>Examples include C, Pascal, Basic, etc.</td>
               <td>Examples include C++, Java, Python, etc.</td>
            </tr>
         </tbody>
      </Table>
      <br/>
      <EmbedYoutube videoType="video" videoList={["Q5MnyFfpbls"]} />
   </div>
</ProgrammmingLanguageWrapper>
);

export default ProgrammmingLanguage;
